module.exports = "\n        <router-outlet></router-outlet>\n       "


//////////////////
// WEBPACK FOOTER
// D:/FMFB/FMFB Dashboard/src/app/main/pages/default/default.component.html
// module id = ../../../../../src/app/main/pages/default/default.component.html
// module chunks = main